import { useEffect, useState } from "react";
import { Buton } from "@koclukpanel/ui";
import { api, metinGetir, type Ben, type HukukiMetin, type RizaTuru } from "./api";
import { Guvenlik } from "./Guvenlik";
import { KvkkBasvurularim } from "./KvkkBasvurularim";
import { Onaylarim, RIZA_ADI, VeriPaketiBolumu } from "./Onaylarim";

export function OnayKilidi({
  ben,
  yenile,
  onCikis,
}: {
  ben: Ben;
  yenile: () => Promise<void>;
  onCikis: () => void;
}) {
  const [basvurular, setBasvurular] = useState(false);
  const [guvenlik, setGuvenlik] = useState(false);
  const [metin, setMetin] = useState<HukukiMetin | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);
  const veliBekleniyor = ben.onayKilidi?.kimVerir === "VELI";
  useEffect(() => {
    if (!veliBekleniyor || ben.gorunumde) return;
    const zamanlayici = setInterval(() => void yenile(), 30_000);
    return () => clearInterval(zamanlayici);
  }, [veliBekleniyor, ben.gorunumde, yenile]);

  const calistir = async (is: () => Promise<unknown>) => {
    setBekliyor(true);
    setHata(null);
    try {
      await is();
    } catch (err) {
      setHata(err instanceof Error ? err.message : "İşlem tamamlanamadı.");
    } finally {
      setBekliyor(false);
    }
  };
  return (
    <main className="mx-auto flex max-w-3xl flex-col gap-4 p-4">
      {ben.gorunumde ? (
        <>
          <h1>Kendi hesabınızın onayları bekleniyor</h1>
          <Buton
            disabled={bekliyor}
            onClick={() =>
              void calistir(async () => {
                await api("/auth/gorunum/bitir", { yontem: "POST" });
                await yenile();
              })
            }
          >
            Kendi hesabıma dön
          </Buton>
        </>
      ) : veliBekleniyor ? (
        <>
          <h1 className="text-xl font-semibold">Velinin onayı bekleniyor</h1>
          <p>Velin aşağıdaki onayları tamamladığında kullanıma devam edebilirsin.</p>
          <ul className="flex flex-col gap-3">
            {ben.onayKilidi!.eksikler.map((tur) => (
              <li key={tur}>
                {RIZA_ADI[tur as RizaTuru] ?? tur}{" "}
                <Buton
                  gorunum="ikincil"
                  disabled={bekliyor}
                  onClick={() =>
                    void calistir(async () => {
                      setMetin(await metinGetir(tur as RizaTuru));
                    })
                  }
                >
                  Metni oku
                </Buton>
              </li>
            ))}
          </ul>
          {metin && (
            <section aria-label="Sözleşme metni">
              <h2>
                {metin.title} — sürüm {metin.version}
              </h2>
              <p className="whitespace-pre-wrap">{metin.body}</p>
              <Buton gorunum="sessiz" onClick={() => setMetin(null)}>
                Kapat
              </Buton>
            </section>
          )}
          <Buton disabled={bekliyor} onClick={() => void calistir(yenile)}>
            Yenile
          </Buton>
        </>
      ) : (
        <>
          <h1 className="text-xl font-semibold">Kullanıma devam etmek için onaylarını tamamla</h1>
          <Onaylarim kilitli onDegisti={yenile} />
        </>
      )}
      {!ben.gorunumde && (
        <>
          <Buton gorunum="ikincil" onClick={() => setGuvenlik(!guvenlik)}>
            {guvenlik ? "Güvenliği kapat" : "Hesap güvenliği"}
          </Buton>
          {guvenlik && <Guvenlik />}
          <Buton gorunum="ikincil" onClick={() => setBasvurular(!basvurular)}>
            KVKK başvurularım
          </Buton>
          {basvurular && <KvkkBasvurularim />}
          <VeriPaketiBolumu />
        </>
      )}
      {hata && <p role="alert">{hata}</p>}
      <Buton gorunum="sessiz" onClick={onCikis}>
        Çıkış
      </Buton>
    </main>
  );
}
